import {Component, OnInit} from '@angular/core';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
//import * as AOS from 'aos';
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  blockTemplate: BlockTemplateComponent | undefined;
  //controlar mensagem spinner
  mensagemSpinner$ = this._spinnerService.mensagem$;
  constructor(private _spinnerService: SpinnerService) {}

  ngOnInit() {
    this._spinnerService.show();
    // this.blockUI.start(); //
    // AOS.init();
    // window.addEventListener('load', AOS.refresh);
    // AOS.init({
    //   duration: 800, // duração da animação em ms
    //   once: true, // anima apenas uma vez
    // });

    setTimeout(() => {
      this._spinnerService.hide();
    }, 800);
  }
}
